<template>
  <FranchiseClinicProductsList />
</template>

<script>
import FranchiseClinicProductsList from '@/views/components/FranchiseClinicProductsList';

export default {
  name: 'ClinicProductsList',
  components: {
    FranchiseClinicProductsList,
  },
};
</script>
